<template>
    <div class="user-component">
        <div class="user-body">
            <b-form data-vv-scope="user-inactive-form">
                <b-form-group
                    id="note"
                    label="Catatan"
                    label-cols-sm="3"
                >
                    <b-form-textarea
                        id="user-note"
                        class="form-profil"
                        name="note"
                        data-vv-as="Catatan"
                        v-model="user_inactive_form.note"
                        placeholder="Catatan"
                        v-validate="'required'"
                        rows="3"
                        max-rows="6"
                        autocomplete="off"
                    ></b-form-textarea>
                    <span :class="{ 'error-validation': errors.first('user-inactive-form.note') }">{{ errors.first('user-inactive-form.note') }}</span>
                </b-form-group>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveData">SIMPAN</b-button>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            id: {
                type: Array,
                default () {
                    return [{}]
                }
            },
            status: {
                type: String,
                default: null
            },
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                user_inactive_form: {
                    id : this.id,
                    status : this.status,
                    note : null,
                },
            };
        },
        methods: {
            resetForm() {
                this.user_inactive_form.note = null,
                this.$validator.reset()
            },
            hideFormModal() {
                EventBus.$emit('hideFormInactiveModal', true)
                this.resetForm()
            },
            async saveData() {
                let scope = 'user-inactive-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.$swal.fire({
                            title: 'Apakah anda yakin?',
                            text: '',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Ya, saya yakin',
                            cancelButtonText: 'Tidak'
                        }).then((result) => {
                            if (result.value) {
                                this.activationMultipleUser()
                            }
                        })
                        // this.updateUser(scope)
                    }
                });
            },
            async activationMultipleUser() {
                let form = this.user_inactive_form
				await this.$store.dispatch('activationMultipleUser', form)
					.then((res) => {
                        this.showLoader = false
                        this.$store.dispatch('getUserSettingList')
                        this.hideFormModal()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
                        this.hideFormModal()
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            // async updateUser(scope) {
            //     this.showLoader = true
            //     let form = this.user_inactive_form
            //     this.$store.dispatch('updateUser', form)
            //         .then((res) => {
            //             this.showLoader = false
            //             this.$store.dispatch('getUserSettingList')
            //             this.hideFormModal()
            //             this.$swal.fire('Success', res.message, 'success')
            //         })
            //         .catch((err)=> {
            //             let error = err.response
            //             this.showLoader = false
            //             if (error.status == 400) {
            //                 this.errorValidate(error.data, scope)
            //             } else {
            //                 this.$swal.fire('Failed', error.data.message, 'error')
            //             }
            //         })
            // },
        },
		created () {
			EventBus.$on('resetForm', (val) => {
				if (val) {
					this.resetForm()
				}
			})
        }
    }
</script>